"use strict";

import {schemeCategory10} from '../utils/schemeCategory10';

const width = 960;
const height = 500;
const margins = {top: 80, right: 100, bottom: 80, left: 100};

export default {
  width: width,
  height: height,
  margins: margins,
}

export const pieProps = {
  width: width,
  height: height,
  margins: margins,
  innerRadius: 0,
  categoricalColors: schemeCategory10,
  pieSort: () => {},
  pieTextShow: true
}